import { ScheduleHour } from '@/classes/ScheduleHour'

export class Process {
  paid: string
  description: string
  idUnit: number
  signatureStart: string
  signatureEnd: string
  signatureStartFallback: string
  signatureEndFallback: string
  preoptStart: string
  preoptEnd: string
  schedule: Array<ScheduleHour>

  constructor (paid:string, description:string, idUnit:number, signatureStart:string, signatureEnd:string, signatureStartFallback:string, signatureEndFallback:string, preoptStart:string, preoptEnd:string, schedules:Array<any>) {
    this.paid = paid
    this.description = description
    this.idUnit = idUnit
    this.signatureStart = signatureStart
    this.signatureEnd = signatureEnd
    this.signatureStartFallback = signatureStartFallback
    this.signatureEndFallback = signatureEndFallback
    this.preoptStart = preoptStart
    this.preoptEnd = preoptEnd
    this.schedule = []

    schedules.forEach(schedule => {
      if (schedule.paid === this.paid) {
        this.schedule.push(new ScheduleHour(
          schedule.hour,
          schedule.monday,
          schedule.tuesday,
          schedule.wednesday,
          schedule.thursday,
          schedule.friday,
          schedule.saturday,
          schedule.sunday
        ))
      }
    })
  }
}
